





































import Vue from 'vue';
import Component from 'vue-class-component';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import { layout, user } from '@/modules/shared/shared/store/namespaces';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import ResumeListComponent from '@/modules/invoicing/components/ResumeListComponent.vue';
import { healthReports } from '@/modules/reports/shared/store/namespaces';
import { HealthReportsActions } from '@/modules/reports/health-reports/store/health-reports.actions';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { HealthReportsGetters } from '@/modules/reports/health-reports/store/health-reports.getters';
import { HealthReport } from '@/modules/reports/health-reports/domain/health-report';
import HealthReportBox from '@/modules/reports/health-reports/components/HealthReportBox.vue';
import { Prop } from 'vue-property-decorator';

@Component({
    components: { HealthReportBox, ResumeListComponent, SectionTitle },
})
export default class HealthReports extends Vue {
    @Prop({ required: false, default: null })
    private customerId!: number;

    isLoading: boolean = true;

    async mounted() {
        this.changeTitle({
            title: 'INFORMES DE SALUD Y GESTIÓN',
            route: ['REPORTES'],
        });
        await this.fetchView();
    }

    async fetchView() {
        this.isLoading = true;
        const failed = await this.fetchReports(this.customerId);
        if (failed) {
            failed.showError();
        }
        this.isLoading = false;
    }

    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;

    @healthReports.Action(HealthReportsActions.FETCH_REPORTS)
    fetchReports!: (customerId: number | null) => Promise<RequestResponse>;

    @healthReports.Getter(HealthReportsGetters.GET_AVAILABLE_REPORTS)
    reports!: HealthReport[];

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;
}
